import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { fetchConfig } from "../../app/common/ducks/config";

export const useAppConfig = ()=>{
    const dispatch = useDispatch();
    const config = useSelector(state => state.config);
    useEffect(() => {
      dispatch(fetchConfig());
    }, [dispatch]);


    useEffect(() => {
        // ssl을 해야 한다면 보내버려야 하는데... 독서영상때문에 음!?
        if(config.useSSL && window.location.protocol === 'http:'){
            var sUrl = 'https://' + window.location.host.replace("www.", "") + window.location.pathname + window.location.search;
            window.location.replace(sUrl);
        }
        
        window.document.title = `${config?.serviceName || ''} 독서길라잡이`;
        

    }, [config]);

    if(config.loading)return false;
    
return true;
}